// Action Type for Payment Method
// Get Payment Method List
export const GET_PAYMENT_METHOD_LIST = "GET_PAYMENT_METHOD_LIST";
export const GET_PAYMENT_METHOD_LIST_SUCCESS =
  "GET_PAYMENT_METHOD_LIST_SUCCESS";
export const GET_PAYMENT_METHOD_LIST_FAILURE =
  "GET_PAYMENT_METHOD_LIST_FAILURE";
